const auth = (state, action) => {
  if (typeof state === 'undefined') return { user: null, error: null };

  switch(action.type) {
    case 'AUTHENTICATE':
      return {
        user: {
          id: action.user.id,
          login: action.user.login,
          name: action.user.name,
          token: action.user.token,
          isSeller: action.user.isSeller,
        },
        error: null,
      };
    case 'DEAUTHENTICATE':
      return { user: null, error: null };
    case 'AUTHENTICATION_ERROR':
      return { user: null, error: action.error };
    default:
      return state;
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js